import { Injectable } from '@angular/core';
import { DacklFilterSingleSelectItem } from '@datev/ngx-dackl';

@Injectable({
  providedIn: 'root',
})
export class ProductGroupMapperService {
  private productGroupMap: Map<string, string> = new Map();

  constructor() {
    this.productGroupMap.set('KEINE_PRODUKTGRUPPE', '');
    this.productGroupMap.set('ABSCHLUSSPRUEFUNG', 'Abschlussprüfung');
    this.productGroupMap.set(
      'BETRIEBLICHES_RECHNUNGSWESEN',
      'Betriebliches Rechnungswesen',
    );
    this.productGroupMap.set('DATEVKOMMUNAL', 'DATEVkommunal');
    this.productGroupMap.set(
      'IT_LOESUNGEN_UND_SECURITY',
      'IT-Lösungen und Security',
    );
    this.productGroupMap.set('OFFICE_MANAGEMENT', 'Office-Management');
    this.productGroupMap.set('PERSONALWIRTSCHAFT', 'Personalwirtschaft');
    this.productGroupMap.set('STEUERN', 'Steuern');
    this.productGroupMap.set(
      'TOOLS_ANDERER_ANBIETER',
      'Tools anderer Anbieter',
    );
    this.productGroupMap.set('WIRTSCHAFTSBERATUNG', 'Wirtschaftsberatung');
    this.productGroupMap.set('WISSEN', 'Wissen');
    this.productGroupMap.set('ZUSATZANGEBOTE', 'Zusatzangebote');
  }

  getProductGroupLabel(key: string, customNoGroupLabel: string = ''): string {
    if (key === 'KEINE_PRODUKTGRUPPE' && customNoGroupLabel !== '') {
      return customNoGroupLabel;
    }
    return this.productGroupMap.get(key) || '';
  }

  getProductGroups(): Array<DacklFilterSingleSelectItem<string>> {
    const arr: Array<DacklFilterSingleSelectItem<string>> = [];
    this.productGroupMap.forEach((mapValue, mapKey) => {
      if (mapKey !== 'KEINE_PRODUKTGRUPPE') {
        arr.push({ value: mapKey, label: mapValue });
      }
    });

    return arr;
  }
}
